// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { SchoolOutcomesSchoolOutcomeSummaryFragmentDoc } from '../../outcomes/__generated-gql-types__/SchoolOutcome.generated';
import { CareerOutcomesCareerOutcomeSummaryFragmentDoc } from '../../outcomes/__generated-gql-types__/CareerOutcome.generated';
import { TestOutcomesTestOutcomeSummaryFragmentDoc } from '../../outcomes/__generated-gql-types__/TestOutcome.generated';
export type CoachGoalSpecificOutcomesCoachFragment = {
  __typename?: 'Coach';
  id: string;
  user: { __typename?: 'User'; id: string; firstName: string };
  outcomes?: Array<
    | {
        __typename?: 'CareerOutcomeSummary';
        number: number;
        companies: Array<{
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'SchoolOutcomeSummary';
        number: number;
        schools: Array<{
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'TestOutcomeSummary';
        scoreRange?: string | null;
        number: number;
        category: { __typename?: 'Category'; id: string; name: string };
      }
  > | null;
};

export type CoachGoalSpecificOutcomesSchoolOutcomeSummaryFragment = {
  __typename?: 'SchoolOutcomeSummary';
  number: number;
  schools: Array<{
    __typename?: 'School';
    id: string;
    name: string;
    logoLink?: string | null;
  }>;
};

export type CoachGoalSpecificOutcomesCareerOutcomeSummaryFragment = {
  __typename?: 'CareerOutcomeSummary';
  number: number;
  companies: Array<{
    __typename?: 'Company';
    id?: string | null;
    name: string;
    logoLink?: string | null;
  }>;
};

export type CoachGoalSpecificOutcomesTestOutcomeSummaryFragment = {
  __typename?: 'TestOutcomeSummary';
  scoreRange?: string | null;
  number: number;
  category: { __typename?: 'Category'; id: string; name: string };
};

export const CoachGoalSpecificOutcomesSchoolOutcomeSummaryFragmentDoc = gql`
  fragment CoachGoalSpecificOutcomes_SchoolOutcomeSummary on SchoolOutcomeSummary {
    ...SchoolOutcomes_SchoolOutcomeSummary
  }
  ${SchoolOutcomesSchoolOutcomeSummaryFragmentDoc}
`;
export const CoachGoalSpecificOutcomesCareerOutcomeSummaryFragmentDoc = gql`
  fragment CoachGoalSpecificOutcomes_CareerOutcomeSummary on CareerOutcomeSummary {
    ...CareerOutcomes_CareerOutcomeSummary
  }
  ${CareerOutcomesCareerOutcomeSummaryFragmentDoc}
`;
export const CoachGoalSpecificOutcomesTestOutcomeSummaryFragmentDoc = gql`
  fragment CoachGoalSpecificOutcomes_TestOutcomeSummary on TestOutcomeSummary {
    ...TestOutcomes_TestOutcomeSummary
  }
  ${TestOutcomesTestOutcomeSummaryFragmentDoc}
`;
export const CoachGoalSpecificOutcomesCoachFragmentDoc = gql`
  fragment CoachGoalSpecificOutcomes_Coach on Coach {
    id
    user {
      id
      firstName
    }
    outcomes {
      ...CoachGoalSpecificOutcomes_SchoolOutcomeSummary
      ...CoachGoalSpecificOutcomes_CareerOutcomeSummary
      ...CoachGoalSpecificOutcomes_TestOutcomeSummary
    }
  }
  ${CoachGoalSpecificOutcomesSchoolOutcomeSummaryFragmentDoc}
  ${CoachGoalSpecificOutcomesCareerOutcomeSummaryFragmentDoc}
  ${CoachGoalSpecificOutcomesTestOutcomeSummaryFragmentDoc}
`;
